const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [^\s]+ failed|Loading CSS chunk [^\s]+ failed|ChunkLoadError/i;

/**
 * True when the error is a lazy-chunk load failure: after a deploy the hashed file a stale tab asks
 * for no longer exists. Looks through the wrappers Angular/zone.js/the router put around the
 * original error (rejection, originalError, cause).
 */
export function isChunkLoadError(error: unknown, depth = 0): boolean {
  if (error == null || depth > 4) return false;
  if (typeof error === 'string') return CHUNK_ERROR_PATTERN.test(error);
  if (typeof error !== 'object') return false;
  const e = error as { name?: unknown; message?: unknown; rejection?: unknown; originalError?: unknown; cause?: unknown };
  if (e.name === 'ChunkLoadError') return true;
  if (typeof e.message === 'string' && CHUNK_ERROR_PATTERN.test(e.message)) return true;
  return isChunkLoadError(e.rejection, depth + 1) || isChunkLoadError(e.originalError, depth + 1) || isChunkLoadError(e.cause, depth + 1);
}
